/**
 * How to use: https://fontawesome.com/how-to-use/on-the-web/using-with/react 
 * e.g. <FontAwesomeIcon icon={["far", "coffee"]} /> represents class='far fa-coffee'
 * NOTE: there should be fas, far, fal, fad. We seem to only have fas and fal accessible
 * 
 * props.size must be in the form of '1x', '2x', '3x', etc.
 */

//https://icons.expo.fyi

import React from 'react';
import { useTheme } from 'styled-components/native';
import {Text, TouchableOpacity} from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import Icons from '../core/WSCIcons';

import Svg, {Path} from 'react-native-svg';
import _ from 'lodash';
const Icon = ({onClick = undefined, size = 20, colour = "black", icon, iconPrefix = "fal", style = undefined, opacityStyle = undefined}) => {
	const theme = useTheme();
	if(icon == undefined){
		icon = "times";
	}

	if(icon.indexOf(":") > -1){
		icon = icon.split(":");
	}

	if(icon.indexOf("wsc") > -1 || icon.indexOf("garbage") > -1){
		let scale = size/16;
		const iconObj = Icons.findIcon(icon, theme);
		const ratio = iconObj.icon[0] / iconObj.icon[1];
		const height = size;
		const width = Math.ceil(size * ratio);
		if (iconObj.viewBox != null){
			scale = 1;
		}
		const translateX = (width-height) * -2;

		return <Svg height={height} width={_.isNaN(width)? 0 : width} style={style} viewBox={iconObj.viewBox != undefined? iconObj.viewBox : null}>
  			<Path d={iconObj.icon[4]}
			  fill={colour} transform={"matrix(" + scale + ",0,0," + scale + "," + translateX + ",0)"}
			  />
		</Svg>
	}

	if (icon.indexOf("lightbulb-dollar") > -1){
		const scale = size/16;
		return <Svg height={size} width={_.isNaN(size)? 0 : size} style={style}>
			<Path d="M10.85,5.73,9.44,5.31a.41.41,0,0,1-.27-.4.38.38,0,0,1,.36-.41h.88a.7.7,0,0,1,.4.12.26.26,0,0,0,.32,0l.37-.35a.25.25,0,0,0,0-.38,1.82,1.82,0,0,0-1-.35V3a.25.25,0,0,0-.25-.25h-.5A.25.25,0,0,0,9.5,3v.5A1.39,1.39,0,0,0,8.17,4.91a1.41,1.41,0,0,0,1,1.36l1.41.42a.41.41,0,0,1,.27.4.39.39,0,0,1-.37.41H9.59a.7.7,0,0,1-.4-.12.26.26,0,0,0-.32,0l-.37.35a.25.25,0,0,0,0,.38,1.82,1.82,0,0,0,1,.35V9a.25.25,0,0,0,.25.25h.5A.25.25,0,0,0,10.5,9V8.5a1.39,1.39,0,0,0,1.33-1.41A1.41,1.41,0,0,0,10.85,5.73ZM10,0A5.5,5.5,0,0,0,5.86,9.12,8.53,8.53,0,0,1,7.5,12v2.35a.49.49,0,0,0,.09.28l.76,1.15a.5.5,0,0,0,.42.22h2.46a.5.5,0,0,0,.42-.22l.76-1.15a.49.49,0,0,0,.09-.28V12a8.44,8.44,0,0,1,1.64-2.88A5.5,5.5,0,0,0,10,0Zm1.5,14.2L11,15H9l-.54-.8V14h3v.2Zm0-1.2h-3V12h3Zm1.89-4.54A10.37,10.37,0,0,0,11.81,11H8.19A10.37,10.37,0,0,0,6.61,8.46a4.5,4.5,0,1,1,6.78,0Z"
			 fill={colour} transform={"scale(" + scale + "," + scale + ")"}
			 />
	   </Svg>;
	}

	let showIcon = icon;
	if( !Array.isArray(showIcon) ){
		if(iconPrefix == undefined){
			iconPrefix = "fal";
		}
		showIcon = [iconPrefix, showIcon];
	}
	
	if (onClick != null){
		return <TouchableOpacity onPress={onClick} style={opacityStyle}>
			<FontAwesomeIcon icon={showIcon} size={size} color={colour} style={style}/>
		</TouchableOpacity>
	}else{
		return <FontAwesomeIcon icon={showIcon} size={size} color={colour} style={style}/>
	}
}

export default Icon;